import VerticalServiceFlow from './VerticalServiceFlow';

export default VerticalServiceFlow;
